/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Save_FailedInputs */

const en_settings_profile_save_failed = /** @type {(inputs: Settings_Profile_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save`)
};

/**
* | output |
* | --- |
* | "Failed to save" |
*
* @param {Settings_Profile_Save_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_profile_save_failed = /** @type {((inputs?: Settings_Profile_Save_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Save_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_profile_save_failed(inputs)
});
export { settings_profile_save_failed as "settings.profile.save_failed" }